import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const LoginView = () => import('@/views/LoginView.vue');
export const NAME_LOGIN = 'Login';
export const PATH_LOGIN = '/login';

export const route: DiscoveredRouteModule = {
  id: 'root.auth.login',
  scope: 'root',
  name: NAME_LOGIN,
  path: PATH_LOGIN,
  component: LoginView,
  meta: { requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true, skipLoading: true },
};
